import { axios, transformAxiosError } from "../utils/axios.create";
import {
  GeofenceSearchParams,
  GeofenceSearchResponse,
  GeofenceDetail,
} from "../domain/geofence.interface";

const search = async (
  params: GeofenceSearchParams,
): Promise<GeofenceSearchResponse> => {
  const queryParams: Record<string, string> = {
    pageNumber: String(params.pageNumber + 1),
    pageSize: String(params.pageSize),
    sortField: params.sortField,
    sortOrder: String(params.sortOrder),
  };

  if (params.search) queryParams.search = params.search;
  if (params.action) queryParams.action = params.action;
  if (params.addressType) queryParams.addressType = params.addressType;
  if (params.programId) queryParams.programId = params.programId;
  if (params.dateFrom) queryParams.dateFrom = params.dateFrom;
  if (params.dateTo) queryParams.dateTo = params.dateTo;

  const qs = new URLSearchParams(queryParams).toString();

  return axios
    .get(`/geofences/search?${qs}`)
    .then((res) => res.data.body)
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

const findById = async (id: string): Promise<GeofenceDetail> => {
  return axios
    .get(`/geofences/${id}/detail`)
    .then((res) => res.data.body)
    .catch((err) => Promise.reject(transformAxiosError(err)));
};

export const GeofencesService = { search, findById };
